import type { Resource } from '../../';
export const country_countries_DZ: Resource = {"default":"Algeria"};
